export const DIETS_PER_PAGE = 30; // same as in the API
